export default __webpack_public_path__ + "static/media/Georgia.5b8bb278.ttf";